import React, { useCallback } from 'react'
import connect from '../connect'
import Typography from '../../../../components/common/Typography'
import { intlDateFormat } from '../../../../utils/dateUtils'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import Checkbox from '@material-ui/core/Checkbox'
import { InlineContainer } from '../../../../components/common/Containers'
import StatusChip from './Status'
import FormMenu from './FormMenu'
import { OrganizationsCell } from '../../../../components/common/Table'

const Item = ({ form, authUser, columns, selected, onSelect }) => {
  const organization = {
    organizationId: form.organizationId,
    orgName: form.organizationName,
  }

  const hasColumn = useCallback(
    key => columns.some(c => c.key === key),
    [columns]
  )

  return (
    <TableRow>
      {hasColumn('select') && (
        <TableCell align="left">
          <Checkbox
            checked={selected}
            onChange={() => onSelect(form.id)}
          />
        </TableCell>
      )}
      {hasColumn('date') && (
        <TableCell align="left">
          <InlineContainer>
            <Typography weight="500" variant="h6">
              {intlDateFormat(form.createdAt)}
            </Typography>
          </InlineContainer>
        </TableCell>
      )}
      {hasColumn('form-name') && (
        <TableCell align="left">
          <Typography variant="body">
            {form.formName || 'N/A'}
          </Typography>
        </TableCell>
      )}
      {hasColumn('admin-status') && (
        <TableCell align="left">
          <Typography
            variant="inherit"
            fontFamily="lexend"
            style={{ padding: '0 16px' }}
          >
            <StatusChip status={form.adminStatus || 'new'} />
          </Typography>
        </TableCell>
      )}
      {hasColumn('organization') && (
        <TableCell align="left">
          <OrganizationsCell organizations={[organization]} />
        </TableCell>
      )}
      {hasColumn('assigned-to') && (
        <TableCell align="left">
          <span style={{ paddingRight: '25px' }}>
            {form.assignedUserName || form.assignedTo || ''}
          </span>
        </TableCell>
      )}
      {hasColumn('score') && (
        <TableCell align="left">
          <Typography variant="body">
            {form.score !== null && form.score !== undefined ? form.score : 'N/A'}
          </Typography>
        </TableCell>
      )}
      <TableCell align="left">
        <FormMenu form={form} />
      </TableCell>
    </TableRow>
  )
}

export default connect(Item)
